import { useState, useEffect, createContext, forwardRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import { Box, Checkbox, Button, Autocomplete, TextField, Drawer, Collapse, Alert, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slide } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { axiosFunction, clearSession, checkPermission } from "../common";
import { Invoice } from "../services/PropertyData";
import InvoiceForm from "../components/Jobs/InvoiceForm";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export const InvoiceContext = createContext(null);

const Invoices = () => {
    const navigate = useNavigate(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [formField, setFormField] = useState({ subtotal: 0, creditAmt: 0, tax_rate: 0, total: 0, balanceCredit: 0 });
    const [userOptions, setUserOptions] = useState(null);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [saveOption, setSaveOption] = useState('');
    const [invoiceFor, setInvoiceFor] = useState({ owner_id: '', property_id: '' });
    const [updateMainList, setUpdateMainList] = useState(false);
    const [invItems, setInvItems] = useState({ items: [{ description: "", quantity: 1, charge: "", amount: "" }] });
    const [ownerCredit, setOwnerCredit] = useState(0);
    const [formChangeFlag, setFormChangeFlag] = useState(false);
    const statusOptions = [{ 'label': 'Paid', 'val': 'Y' }, { 'label': 'Pending', 'val': 'N' }, { 'label': 'Cancelled', 'val': 'C' }];
    const { reset, handleSubmit, register, formState: { errors } } = useForm();

    //const [serviceUsersOptions, setServiceUsersOptions] = useState(null);
    //const [jobStatusOptions, setJobStatusOptions] = useState(null);
    const [cancelInvoice, setCancelInvoice] = useState({});
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [statusInvoice, setStatusInvoice] = useState({});
    const [statusConfirmOpen, setStatusConfirmOpen] = useState(false);
    const [cancelLoader, setCancelLoader] = useState(false);
    const [sendLoader, setSendLoader] = useState(false);
    const [invoiceSent, setInvoiceSent] = useState('N');
    const [invoiceId, setInvoiceId] = useState('');
    const [invoiceConfirmOpen, setInvoiceConfirmOpen] = useState(false);
    const [xeroConfirmOpen, setXeroConfirmOpen] = useState(false);
    const [xeroSent, setXeroSent] = useState('N');
    const [xeroLoader, setXeroLoader] = useState(false);
    const [xeroRotate, setXeroRotate] = useState('');
    const [loaderText, setLoaderText] = useState(false);
    const [invoiceDTColumns, setInvoiceDTColumns] = useState([]);
    const [invoiceLoader, setInvoiceLoader] = useState(false);

    const [searchFields, setSearchFields] = useState({
        "from_date": dayjs().startOf('month').format('YYYY-MM-DD'),
        "to_date": dayjs().endOf('month').format('YYYY-MM-DD'),
        "status": ""
    });

    const loadData = async () => {
        try {
            const userDataList = await axiosFunction('auth/users', 'post', {});
            if (userDataList.status === 'success') {
                setUserOptions(userDataList.data);
            } else {
                setAlertOpen(true);
                setAlertStatus('error');
                setAlertMessage(userDataList.message);
            }
        } catch (e) {
            setAlertOpen(true);
            setAlertStatus('error');
            setAlertMessage(e.message);
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            }
        }
    }

    const fetchData = async () => {

        try {
            //console.log('fetchData', params);
            setLoaderText(true);
            let params = searchFields;

            const response = await axiosFunction('invoices', 'get', params);
            if (response.status === 'success') {
                setInvoiceDTColumns(response.data);
                setUpdateMainList(true);
                setLoaderText(false);
            } else {
                //setQuoteLoader(false);
                /* if (response?.response?.status === 401) {
                    clearSession();
                    navigate('/login');
                } */
                setLoaderText(false);
            }

        } catch (e) {
            if (e?.response?.status === 401) {
                clearSession();
                navigate("/login");
            } else {
                console.log(e);
            }
            setLoaderText(false);
            //setQuoteLoader(false);
        }

    }

    useEffect(() => {
        loadData();

        setSearchFields({
            from_date: dayjs().startOf('month').format('YYYY-MM-DD'),
            to_date: dayjs().endOf('month').format('YYYY-MM-DD')
        });

        onSearch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAdd = () => {
        setFormField({ subtotal: 0, creditAmt: 0, tax_rate: 0, total: 0, balanceCredit: 0, extCreditAmt: 0, extBalanceCredit: 0, action: 'add' });
        setInvoiceFor({ owner_id: '', property_id: '' });
        setOwnerCredit(0);
        setInvItems({ items: [{ description: '', quantity: 1, charge: '', amount: '' }] });
        setDrawerOpen(true);
    }

    const handleDialogClose = () => {
        setInvoiceFor({ owner_id: '', property_id: '' });
        setFormField({ subtotal: 0, creditAmt: 0, tax_rate: 0, total: 0, balanceCredit: 0 });
        setOwnerCredit(0);
        setSaveOption('');
        // setUpdateMainList(formChangeFlag);
        setDrawerOpen(false);
    };

    const handleAutoClose = () => {
        window.scrollTo(0, 0);
        setTimeout(() => setAlertOpen(false), 5000);
    };

    const handleInvoiceCancel = (id) => {
        var data = {
            id: id,
            _method: 'PUT',
            action: 'cancel'
        }
        setCancelInvoice(data);
        setConfirmOpen(true);
    }

    const handleCancel = async () => {
        try {
            setCancelLoader(true);
            const cancelResponse = await axiosFunction('invoices/' + cancelInvoice.id, 'post', cancelInvoice);
            setAlertOpen(true);
            if (cancelResponse.status === 'success') {
                setAlertStatus('success');
                setAlertMessage(cancelResponse.message);
                handleAutoClose();
                setConfirmOpen(false);
                setCancelInvoice({});
                setUpdateMainList(true);
                setCancelLoader(false);
            } else {
                setAlertStatus('error');
                setAlertMessage(cancelResponse.message);
                setConfirmOpen(false);
                setCancelInvoice({});
                setCancelLoader(false);
            }

        } catch (e) {
            setConfirmOpen(false);
            setCancelInvoice({});
            setCancelLoader(false);
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            }
        }
    };

    const handleInvoiceStatus = (id) => {
        var data = {
            id: id,
            _method: 'PUT',
            action: 'status'
        }
        setStatusInvoice(data);
        setStatusConfirmOpen(true);
    }

    const handleStatus = async () => {
        try {
            setCancelLoader(true);
            const statusResponse = await axiosFunction('invoices/' + statusInvoice.id, 'post', statusInvoice);
            setAlertOpen(true);
            if (statusResponse.status === 'success') {
                setAlertStatus('success');
                setAlertMessage(statusResponse.message);
                handleAutoClose();
                setStatusConfirmOpen(false);
                setStatusInvoice({});
                setUpdateMainList(true);
                setCancelLoader(false);
            } else {
                setAlertStatus('error');
                setAlertMessage(statusResponse.message);
                setStatusConfirmOpen(false);
                setStatusInvoice({});
                setCancelLoader(false);
            }

        } catch (e) {
            setConfirmOpen(false);
            setStatusInvoice({});
            setCancelLoader(false);
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            }
        }
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
        setCancelInvoice({});
    };

    const handleSendInvoice = (id, sent) => {
        setInvoiceSent(sent);
        setInvoiceId(id);
        setInvoiceConfirmOpen(true);
    }

    const handleSend = async () => {
        try {
            setSendLoader(true);
            const sendResponse = await axiosFunction('auth/sendinvoice', 'post', { invoice_id: invoiceId });
            setAlertOpen(true);
            if (sendResponse.status === 'success') {
                handleInvoiceConfirmClose();
                setAlertStatus('success');
                setAlertMessage(sendResponse.message);
                handleAutoClose();
                setUpdateMainList(true);
                setSendLoader(false);
            } else {
                handleInvoiceConfirmClose();
                setAlertStatus('error');
                setAlertMessage(sendResponse.message);
                setSendLoader(false);
            }

        } catch (e) {
            handleInvoiceConfirmClose();
            setSendLoader(false);
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            }
        }
    }

    const handleInvoiceConfirmClose = () => {
        setInvoiceSent('N');
        setInvoiceId('');
        setInvoiceConfirmOpen(false);
    };

    const handleStatusConfirmClose = () => {
        setInvoiceSent('N');
        setInvoiceId('');
        setStatusConfirmOpen(false);
    };

    const handleInvoiceXero = (id, xero_invoice_id) => {
        setInvoiceId(id);
        setXeroConfirmOpen(true);
        if (xero_invoice_id) {
            setXeroSent('Y');
        }
    }

    const handleSendXero = async () => {
        try {
            setXeroLoader(true);
            setXeroRotate(invoiceId);
            const xeroResponse = await axiosFunction('xero/createinvoice', 'post', { invoice_id: invoiceId });
            setAlertOpen(true);
            if (xeroResponse.status === 'success') {
                handleXeroConfirmClose();
                setAlertStatus('success');
                setAlertMessage(xeroResponse.message);
                handleAutoClose();
                setUpdateMainList(true);
                setXeroLoader(false);
            } else {
                handleXeroConfirmClose();
                setAlertStatus('error');
                setAlertMessage(xeroResponse.message);
                setXeroLoader(false);
            }

        } catch (e) {
            handleXeroConfirmClose();
            setXeroLoader(false);
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            }
        }
    }

    const handleXeroConfirmClose = () => {
        setInvoiceId('');
        setXeroSent('N');
        setXeroConfirmOpen(false);
        setXeroRotate('');
    };

    const onSearch = async () => {
        if (searchFields.from_date || searchFields.to_date || searchFields.status) {

            var params = {};
            if (searchFields.from_date) params.from_date = dayjs(searchFields.from_date).format('YYYY-MM-DD');
            if (searchFields.to_date) params.to_date = dayjs(searchFields.to_date).format('YYYY-MM-DD');
            if (searchFields.status) params.status = searchFields.status;

            fetchData();
        }
    }

    const handleSearchReset = () => {
        if (searchFields.from_date || searchFields.to_date) {
            setSearchFields({
                "from_date": "",
                "to_date": ""
            });
            reset(searchFields);

            fetchData();
        }
    }

    const getSelectedItem = (seloptions) => {
        // return  [agentData[0], agentData[5]];
        let Items = [];
        if (Items) {
            let i = 0;
            // eslint-disable-next-line   
            statusOptions.find((opt) => {
                // eslint-disable-next-line 
                seloptions.map((item) => {
                    if (opt.val === item) {
                        Items[i] = opt;
                        i++;
                    }
                });
            });
        }
        //console.log(Items);

        return Items || [];
    }

    return (
        <>
            <SiteHeader menu='invoices' />
            <div className="user-panel">
                <div className="title text-start">Invoices</div>
                <div className="container-fluid">
                    <Dialog
                        open={xeroConfirmOpen}
                        TransitionComponent={Transition}
                    >
                        <DialogTitle>Are you sure you want to synchronize this invoice with Xero?</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                {xeroSent === 'Y' && <span className="text-warning">Invoice has been already synchronized. </span>}
                                If yes, the invoice will be synchronize {xeroSent === 'Y' && '/update'} with Xero.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button className="themeholy-btn btn-secondary" onClick={handleXeroConfirmClose} disabled={xeroLoader}>Cancel</Button>
                            <Button className="themeholy-btn btn-primary" onClick={() => handleSendXero()} disabled={xeroLoader}>{xeroLoader ? <i className="fa fa-spin fa-gear"></i> : 'Yes'}</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={invoiceConfirmOpen}
                        TransitionComponent={Transition}
                    >
                        <DialogTitle>Are you sure you want to send this invoice?</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                {invoiceSent === 'Y' && <span className="text-warning">Invoice has been already sent. </span>}
                                If yes, the invoice will be sent{invoiceSent === 'Y' && ' again'}.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button className="themeholy-btn btn-secondary" onClick={handleInvoiceConfirmClose} disabled={sendLoader}>Cancel</Button>
                            <Button className="themeholy-btn btn-primary" onClick={() => handleSend()} disabled={sendLoader}>{sendLoader ? <i className="fa fa-spin fa-gear"></i> : 'Yes'}</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={confirmOpen}
                        TransitionComponent={Transition}
                    >
                        <DialogTitle>Are you sure you want to cancel this invoice?</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                If yes, invoice will be cancelled. If any credit deducted for the cancelled invoice that will be refunded.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button className="themeholy-btn btn-secondary" onClick={handleConfirmClose} disabled={cancelLoader}>Cancel</Button>
                            <Button className="themeholy-btn btn-primary" onClick={() => handleCancel()} disabled={cancelLoader}>{cancelLoader ? <i className="fa fa-spin fa-gear"></i> : 'Yes'}</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={statusConfirmOpen}
                        TransitionComponent={Transition}
                    >
                        <DialogTitle>Are you sure you want to change the invoice as paid?</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                If yes, the invoice status will be changed as paid.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button className="themeholy-btn btn-secondary" onClick={handleStatusConfirmClose} disabled={cancelLoader}>Cancel</Button>
                            <Button className="themeholy-btn btn-primary" onClick={() => handleStatus()} disabled={cancelLoader}>{cancelLoader ? <i className="fa fa-spin fa-gear"></i> : 'Yes'}</Button>
                        </DialogActions>
                    </Dialog>
                    <div className="row">
                        <div className="col-md-12">
                            <Collapse in={alertOpen}>
                                <Alert variant="filled" severity={alertStatus}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setAlertOpen(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                    sx={{ mb: 2, id: "alertmessage" }}
                                >
                                    {alertMessage}
                                </Alert>
                            </Collapse>
                        </div>
                        {checkPermission('INVOICE', 'search') &&
                            <Box component="form" id="search-form" name="search-form" noValidate autoComplete="off" onSubmit={handleSubmit(onSearch)} className="row">

                                <div className="col-12 col-md-4 d-flex">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="From Date *"
                                            format="DD/MM/YYYY"
                                            name="from_date"
                                            {...register("from_date", { required: "From Date is required" })}
                                            maxDate={dayjs(searchFields.to_date ? searchFields.to_date : dayjs(new Date(new Date().setMonth(new Date().getMonth() + 12))).format('YYYY-MM-DD'))}
                                            value={dayjs(searchFields?.from_date)}
                                            onChange={(newValue) => { setSearchFields((prev) => ({ ...prev, from_date: dayjs(newValue).format('YYYY-MM-DD') })) }}
                                            sx={{ margin: '15px' }}
                                            slotProps={{
                                                textField: {
                                                    error: errors.from_date ? true : false,
                                                    helperText: errors.from_date?.message
                                                },
                                            }}
                                        />

                                        <DatePicker
                                            label="To Date *"
                                            format="DD/MM/YYYY"
                                            name="to_date"
                                            {...register("to_date", { required: "To Date is required" })}
                                            minDate={dayjs(searchFields.from_date)}
                                            maxDate={dayjs(new Date(new Date().setMonth(new Date().getMonth() + 12)))}
                                            value={dayjs(searchFields?.to_date)}
                                            onChange={(newValue) => { setSearchFields((prev) => ({ ...prev, to_date: dayjs(newValue).format('YYYY-MM-DD') })) }}
                                            sx={{ margin: '15px' }}
                                            slotProps={{
                                                textField: {
                                                    error: errors.to_date ? true : false,
                                                    helperText: errors.to_date?.message,

                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className="col-6 col-md-4">
                                    <Autocomplete
                                        multiple
                                        fullWidth
                                        id="checkboxes-tags-jobstatus"
                                        options={statusOptions}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.label}
                                        renderOption={(props, option, { selected }) => {
                                            const { key, ...optionProps } = props;
                                            return (
                                                <li key={key} {...optionProps}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selected}
                                                    />
                                                    {option.label}
                                                </li>
                                            );
                                        }}

                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Status" placeholder="Search By Status" />
                                        )}

                                        onChange={(_event, val, _reason) => {
                                            // console.log(val)

                                            setSearchFields((prev) => ({ ...prev, status: val ? val.map(v => v.val) : [] }))
                                        }}

                                        value={searchFields.status ? getSelectedItem(searchFields.status) : []}
                                    />
                                </div>
                                <div className="col-6 col-md-4 d-flex flex-row">
                                    <Button type="submit" className="themeholy-btn btn-primary m-2 mt-3" style={{ height: '50px' }} disabled={loaderText}>{(loaderText) ? 'Searching...' : 'Search'}</Button>

                                    <Button type="button" className="themeholy-btn btn-secondary m-2 mt-3" style={{ height: '50px' }} onClick={() => handleSearchReset()} >Reset</Button>
                                </div>
                            </Box >
                        }
                        <div className="col-md-12 text-end mb-3">
                            <Button className="themeholy-btn btn-primary" style={{ marginLeft: "auto" }} onClick={handleAdd}>Add New Invoice</Button>
                        </div>
                        <div className="col-md-12">
                            <Invoice
                                updateTabList={updateMainList}
                                searchFields={searchFields}
                                setUpdateTabList={setUpdateMainList}
                                setInvItems={setInvItems}
                                setFormField={setFormField}
                                setDrawerOpen={setDrawerOpen}
                                setOwnerCredit={setOwnerCredit}
                                handleInvoiceCancel={handleInvoiceCancel}
                                handleSendInvoice={handleSendInvoice}
                                handleInvoiceXero={handleInvoiceXero}
                                xeroRotate={xeroRotate}
                                setXeroRotate={setXeroRotate}
                                handleInvoiceStatus={handleInvoiceStatus}
                                invoiceDTColumns={invoiceDTColumns}
                                invoiceLoader={invoiceLoader}
                                setInvoiceLoader={setInvoiceLoader}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <InvoiceContext.Provider value={
                {
                    formField, setFormField, userOptions,
                    handleDialogClose, saveOption, setSaveOption, invoiceFor, setInvoiceFor,
                    invItems, ownerCredit, setOwnerCredit, formChangeFlag, setFormChangeFlag, onSearch
                }
            }>
                {drawerOpen && <Drawer anchor="right" open={drawerOpen} sx={{ zIndex: 1400 }} PaperProps={{ className: 'container p-0' }}>
                    <InvoiceForm mainAlertStatus={setAlertStatus} mainAlertOpen={setAlertOpen} mainAlertMessage={setAlertMessage} mainAlertAutoClose={handleAutoClose} />
                </Drawer>}
            </InvoiceContext.Provider >
            <Footer />
        </>
    );
}

export default Invoices;